// Central scroll lock manager — prevents conflicts when multiple components
// (Dashboard mobile menu, History detail view, Modal) try to lock body scroll.
// Uses ref-counting: scroll is locked while count > 0, unlocked when count === 0.

let lockCount = 0;

export function lockScroll(): void {
  lockCount++;
  if (lockCount === 1) {
    document.body.style.overflow = 'hidden';
  }
}

export function unlockScroll(): void {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.style.overflow = '';
  }
}
